import image from "./mainCarousel/1.jpg";


export const MAIN_CAROUSEL = [
    {id: 1, altText: "Image 1", src: image}
];
